<template>
  <div class="schedule">
    <input type="time" v-model="from" />
    <span class="delimiter">&ndash;</span>
    <input type="time" v-model="to" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      from: null,
      to: null,
    };
  },
  watch: {
    from() {
      this.$emit('input', this.combined);
    },
    to() {
      this.$emit('input', this.combined);
    },
    value: {
      immediate: true,
      handler(value) {
        if (typeof value !== 'string') {
          return;
        }

        const [from, to] = value.split('-').map(i => i.trim());

        this.from = from;
        this.to = to;
      },
    },
  },
  computed: {
    combined() {
      return `${this.from} - ${this.to}`;
    },
  },
};
</script>

<style scoped src="./inputTime.css"></style>
